<template>
  <div class="field-item">
    <div class="field-label">
      {{ field.label }}<i v-if="field.fill_status" class="impor">*</i>
    </div>
    <div class="field-control">
      <div class="dyn-file">
        <label class="dyn-file-btn" :for="uid + '_input'">
          {{ field.prompt || '選擇文件' }}
        </label>
        <input :id="uid + '_input'" type="file" style="display:none" @change="onFileChange" />
        <span class="dyn-file-name">{{ fileItem ? fileItem.name : '' }}</span>
        <span :class="['dyn-file-status', fileItem && fileItem.status]">{{ fileStatus }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadSignFile } from '@/api/activity'

export default {
  name: 'FieldFile',
  props: { field: Object, value: { default: '' } },
  data () { return { fileItem: null } },
  computed: {
    uid () { return `file_${this.field.value}` },
    fileStatus () {
      if (!this.fileItem) return ''
      return { uploading: '上傳中…', done: '✓ 已上傳', error: '上傳失敗，請重新選擇' }[this.fileItem.status] || ''
    }
  },
  methods: {
    async onFileChange (e) {
      const f = (e.target.files || [])[0]
      e.target.value = ''
      if (!f) { this.fileItem = null; this.$emit('input', ''); return }
      this.fileItem = { name: f.name, path: '', url: '', file: f, status: 'uploading' }
      try {
        const res = await uploadSignFile(f)
        if (res.code === 200 && res.data && res.data.path) {
          this.fileItem.path = res.data.path
          this.fileItem.status = 'done'
          this.$emit('input', res.data.path)
        } else {
          this.fileItem.status = 'error'
          this.$emit('input', '')
        }
      } catch (e) {
        this.fileItem.status = 'error'
        this.$emit('input', '')
      }
    },
    hasUploading () { return this.fileItem && this.fileItem.status === 'uploading' },
    hasError () { return this.fileItem && this.fileItem.status === 'error' },
    reset () { this.fileItem = null }
  }
}
</script>

<style scoped>
.dyn-file { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.dyn-file-btn {
  display: inline-block;
  padding: 6px 14px;
  border: 1px dashed #188AFF;
  border-radius: 4px;
  color: #188AFF;
  background: #f7fbff;
  cursor: pointer;
  font-size: 16px;
}
.dyn-file-name { color: #666; font-size: 15px; }
.dyn-file-status { font-size: 14px; }
.uploading { color: #E6A23C; }
.done { color: #67C23A; }
.error { color: #f56c6c; }
@media screen and (max-width: 768px) {
  .dyn-file { width: 100%; }
  .dyn-file-btn { display: block; width: 100%; text-align: center; padding: 10px 0; }
  .dyn-file-name { width: 100%; margin-top: 6px; word-break: break-all; }
}
</style>
